export default __webpack_public_path__ + "static/media/wuyeThree.8f5f6284.png";